"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchJSON = exports.useFetch = void 0;
const url_1 = require("url");
const react_1 = __importDefault(require("react"));
const anypoint_fetch_1 = __importDefault(require("@mulesoft/anypoint-fetch"));
const config_1 = require("./config");
const user_1 = require("./user");
const errors_1 = require("./errors");
/**
 * Will return a function to execute a request to the Exchange API
 *
 * @example
 *
 * ```ts
 * import { useFetch } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const fetch = useFetch();
 *   const [myState, setMyState] = React.useState();
 *
 *   React.useEffect(() => {
 *     async function init() {
 *       const response = await fetch('/api/v2/something', { method: 'POST' });
 *       const json = await response.json();
 *
 *       setMyState(json);
 *     }
 *
 *     init();
 *   }, []);
 * };
 * ```
 *
 * Notice that context is not required and will be sent automatically by the hook
 *
 * @param uri to use in fetch
 * @returns A function to execute a request
 */
function useFetch(uri) {
    const config = (0, config_1.useConfig)();
    const fetch = (0, anypoint_fetch_1.default)({ config });
    const context = (0, user_1.useSessionContext)();
    const getContext = (0, user_1.useGetSessionContext)();
    return (pathname, params) => {
        var _a;
        const url = (0, url_1.format)(uri !== null && uri !== void 0 ? uri : config.api.uri);
        return fetch(`${url}${pathname}`, Object.assign(Object.assign({}, params), { context: (_a = getContext === null || getContext === void 0 ? void 0 : getContext()) !== null && _a !== void 0 ? _a : context }));
    };
}
exports.useFetch = useFetch;
function useFetchJSON(url, callbackOrDependencies, paramsOrDependencies, fourthParam) {
    const [isLoading, setIsLoading] = react_1.default.useState(true);
    const [json, setJSON] = react_1.default.useState(null);
    const [error, setError] = react_1.default.useState(null);
    const handleError = (0, errors_1.useErrorHandling)();
    const fetch = useFetch();
    const [dependencies, params] = 
    // If callback is provided uses 2nd and 3rd parameter as dependencies and params else 3rd and 4th parameter
    typeof callbackOrDependencies === 'function'
        ? [paramsOrDependencies, fourthParam]
        : [callbackOrDependencies, paramsOrDependencies];
    react_1.default.useEffect(() => {
        (function init() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    setIsLoading(true);
                    setError(null);
                    const response = yield fetch(url, params);
                    const responseJSON = yield response.json();
                    setJSON(responseJSON);
                    if (typeof callbackOrDependencies === 'function') {
                        callbackOrDependencies(responseJSON);
                    }
                }
                catch (requestError) {
                    setError(requestError);
                    handleError(requestError, init);
                }
                finally {
                    setIsLoading(false);
                }
            });
        })();
    }, dependencies !== null && dependencies !== void 0 ? dependencies : []);
    return {
        isLoading,
        error,
        json
    };
}
exports.useFetchJSON = useFetchJSON;
